import { rowsHaveAllColumns, rowsHaveColumn } from '../transforms/columnGuards';
import type { TransformRow } from '../transforms/types';
import { RenderAdapterError } from './types';

/**
 * Non-throwing column guard for plain row arrays. Empty row sets skip
 * validation (mirrors admin schema-only preflight when data is empty).
 */
export function assertRequiredColumns(
  rows: readonly TransformRow[],
  required: readonly string[],
): RenderAdapterError | undefined {
  if (required.length === 0 || rows.length === 0) {
    return undefined;
  }
  if (rowsHaveAllColumns(rows, required)) {
    return undefined;
  }
  const missing = required.filter((column) => !rowsHaveColumn(rows, column));
  return new RenderAdapterError('missing_columns', missing);
}
